<script setup lang="ts">
export interface Props {
  label?: string;
  columns?: number;
}
const props = withDefaults(defineProps<Props>(), {
  label: '',
  columns: 4,
});
</script>

<template>
  <section
    :class="$style.jobBookingSection"
    :style="{ '--columns': props.columns }"
    data-testid="jobBookingSection"
  >
    <span v-if="props.label" :class="$style.label">{{ props.label }}</span>
    <div :class="$style.grid">
      <slot />
    </div>
  </section>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

.jobBookingSection {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
  .label {
    font-size: 0.6875rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: colors.$color-text-secondary;
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(var(--columns), 1fr);
    gap: 1rem;
  }
</style>
